import axios from 'axios';
import { z } from 'zod';

import GlobalSiteTagService from 'services/GlobalSiteTagService';
import { strictQuery } from 'utils/strict-query';

import { CouponZod } from 'types/zod/coupon';

const StripeApi = {
    createTapfiliateRecord: (params: { paymentIntentId: string; amount: number; customerId?: string }): void => {
        const { paymentIntentId, amount, customerId } = params;
        try {
            if (paymentIntentId) {
                if (window.tap && customerId) {
                    if (amount) {
                        tap('conversion', paymentIntentId, amount, { customer_id: customerId });
                    } else {
                        tap('trial', customerId);
                    }
                }

                GlobalSiteTagService.addConversionEvent('PQS2COH64pYDELbXiMgB');
            }
        } catch (e) {
            console.error(e);
        }
    },

    getCoupons: strictQuery({
        In: z.number(),
        Out: z.array(CouponZod),
        handler: (groupId) => axios.get(`/stripe/coupons`, { params: { groupId } }),
    }),

    shippingPayment: strictQuery({
        In: z.number(),
        Out: z.object({ redirect: z.string() }),
        handler: (id) => axios.post(`/qinstances/${id}/shipping-payment`),
    }),

    giftPayment: strictQuery({
        In: z.number(),
        Out: z.object({ redirect: z.string() }),
        handler: (id) => axios.post(`/qinstances/${id}/gift-payment`),
    }),
};

export default StripeApi;
